"use strict";

import PageCommon from "./PageCommon";
import LicensesTrack from "./Tracks/LicensesTrack";

import Globals from "../Globals.js";

export default class LicensesManager extends PageCommon {
    constructor() {
        super();

        this.page = {};
        this.prices = [];
        this.licensesTracks = [];
        this.total = 0;
        this.timeSteps = 1; // Months number
        this.territoryLicensesTrackSelected = null;
        this.exclusiveTypes = ["Full", "Product Area"];
        this.artistTypes = ["Producer", "Artist", "Maker"];

        this.tracks = null;
        this.artists = null;
        this.artists_formats = null;
        this.userLogged = null;

        this.areas = [];
        this.continents = [];
        this.countries = [];
        this.national = [];
        this.world = [];

        this.isWorking = false;

        this.singleLicense = 0;

        this.paymentUrl = {
            return_url_ok: `${window.location.origin}/thank-you?payment=OK`,
            return_url_err: `${window.location.origin}/licenses?payment=ERROR`,
        };

        this.redirectIfEmptyUrl = "/find-music";
    }
    init({ pageName, tracks, artists, artists_formats, userManager }) {
        super.init();

        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - init");

        this.pageName = pageName;
        this.tracks = tracks;
        this.artists = artists;
        this.artists_formats = artists_formats;
        this.userManager = userManager;
        this.userLogged = userManager.userLogged;

        this.isVatString = "";
        if (this.userLogged) {
            if (this.userLogged.is_italy || (this.userLogged.is_company === false && this.userLogged.is_eurozone === true)) {
                this.isVatString = "+ VAT";
            }
        }

        const _this = this;

        this.updateMenuLicensesTable();

        if (pageName !== "licenses") {
            document.addEventListener("add_track_to_licenses", (event) => {
                const track = event.detail.track;
                let licenses_tracks = window.localStorage.getItem("licenses_tracks");
                if (licenses_tracks && licenses_tracks !== "") {
                    licenses_tracks = licenses_tracks.split(",");
                    if (licenses_tracks.indexOf(track.ID.toString()) > -1) {
                        const modal = "#licensesStatusModal";
                        document.querySelector(`${modal} .message`).textContent = "ALREADY ADDED";
                        jQuery(modal).modal("show");
                        setTimeout(() => jQuery(modal).modal("hide"), 3000);
                        return;
                    }
                } else {
                    licenses_tracks = [];
                }
                licenses_tracks.push(track.ID);
                window.localStorage.setItem("licenses_tracks", licenses_tracks.join(","));
                document.querySelector("#mainMenu .licenses .nav-link .badge").textContent = licenses_tracks.length === 0 ? "" : licenses_tracks.length;
                _this.addTrack(track);
                /* // Modal
                const modal = "#licensesStatusModal";
                document.querySelector(`${modal} .message`).textContent = "ADDED";
                jQuery(modal).modal("show");
                setTimeout(() => jQuery(modal).modal("hide"), 3000);
                //*/
                location.href = "/licenses";
            });
        }

        const modal = "#territoryProceedModal";
        document.querySelector(`${modal} button.proceed`).addEventListener("click", (event) => {
            const licensesSingleTrack = document.querySelector(`#licensesSingleItem${_this.territoryLicensesTrackSelected.data.id}`);
            licensesSingleTrack.querySelector(".tags-list").style.display = "none";
            licensesSingleTrack.querySelector(".add-territory").style.display = "none";
            const worldWide = _this.page.Zones.filter((item) => item.name === "Worldwide")[0];
            _this.territoryLicensesTrackSelected.data.zone = [];
            _this.territoryLicensesTrackSelected.data.zone.push(worldWide.ID);
            _this.requestPriceUpdate(_this.territoryLicensesTrackSelected.data.id);
        });
        document.querySelector(`${modal} button.cancel`).addEventListener("click", (event) => {
            const licensesSingleTrack = document.querySelector(`#licensesSingleItem${_this.territoryLicensesTrackSelected.data.id}`);
            licensesSingleTrack.querySelector(".territory-worldwide").checked = false;
            licensesSingleTrack.querySelector(".tags-list").style.display = "flex";
            licensesSingleTrack.querySelector(".add-territory").style.display = "flex";
        });
    }

    updateMenuLicensesTable() {
        const licensesEmptyElement = document.querySelector("#mainMenu .licenses-empty");
        const licensesListElement = document.querySelector("#mainMenu .licenses-list");

        licensesEmptyElement.style.display = "";
        licensesListElement.style.display = "none";
        licensesListElement.querySelector(".tracks-list-body").textContent = "";

        if (this.userLogged || window.localStorage.getItem("licenses_tracks") !== "") {
            licensesListElement.querySelector(".calculate").style.display = "";
            licensesListElement.querySelector(".login").style.display = "none";
        } else {
            licensesListElement.querySelector(".calculate").style.display = "none";
            licensesListElement.querySelector(".login").style.display = "";
        }

        if (window.localStorage.getItem("licenses_tracks") && window.localStorage.getItem("licenses_tracks") !== "") {
            const tracks_data = window.localStorage.getItem("licenses_tracks").split(",");
            tracks_data.map((id) => {
                const track = this.tracks.get({ id });
                track.setupArtistsObject(this.artists);
                this.addTrack(track.data);
            });
        }
    }

    addTrack(track) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Add Track");

        const _this = this;

        document.querySelector("#mainMenu .licenses-empty").style.display = "none";
        document.querySelector("#mainMenu .licenses-list").style.display = "";

        const modelId = "#model-licenses-track-list";
        const licensesItem = document.querySelector(`${modelId} .track-item`).cloneNode(true);
        licensesItem.querySelector(".tl-track").textContent = track.Name;

        if (track.Artists.length > 0) {
            if (track.Artists[0]) {
                licensesItem.querySelector(".tl-artist").href = this.setUrlParams("/artist/" + this._normalizza_track_prop(track.Artists[0].data.Name), [
                    { key: "id", value: track.Artists[0].data.ID },
                    { key: "format", value: this._normalizza_track_prop(track.Artists[0].data.Format) },
                ]);
            } else {
                licensesItem.querySelector(".tl-artist").href = "javascript:void(0)";
            }
            licensesItem.querySelector(".tl-artist").innerHTML = track.Artists.map((artist) => {
                if (artist) {
                    return artist.get().Name;
                }
                return "";
            }).join(", ");
        }

        licensesItem.querySelector(".tl-length").textContent = track.MP3.LengthFMT;

        licensesItem.querySelector("button.remove-btn").addEventListener("click", (event) => {
            event.preventDefault();
            licensesItem.remove();
            const licenses_tracks = window.localStorage.getItem("licenses_tracks").split(",");
            licenses_tracks.splice(licenses_tracks.indexOf(track.ID.toString()), 1);
            window.localStorage.setItem("licenses_tracks", licenses_tracks.join(","));
            document.querySelector("#mainMenu .licenses .nav-link .badge").textContent = licenses_tracks.length === 0 ? "" : licenses_tracks.length;
            if (document.querySelector("#mainMenu .licenses-list .tracks-list-body").childNodes.length === 0) {
                document.querySelector("#mainMenu .licenses-empty").style.display = "";
                document.querySelector("#mainMenu .licenses-list").style.display = "none";
            }
            if (_this.pageName === "licenses") {
                window.location.reload();
            }
        });

        document.querySelector("#mainMenu .licenses-list .tracks-list-body").appendChild(licensesItem);
    }

    getPageData({ payment }) {
        const _this = this;
        const token = this.getCookie("user_token");
        const urlParams = this.getUrlParams();
        if (urlParams.get("force-track")) {
            const licensesTrack = new LicensesTrack({ id: urlParams.get("force-track") });
            this.licensesTracks.push(licensesTrack);
            window.history.replaceState(null, "", "licenses");
        } else if (window.localStorage.getItem("licenses_tracks") === "" || window.localStorage.getItem("licenses_tracks") === null) {
            const randomTrack = this.shuffle(this.tracks.data)[0].data.ID;
            const licensesTrack = new LicensesTrack({ id: randomTrack });
            this.licensesTracks.push(licensesTrack);
            document.querySelector("#genericStatusModal .medium-title").textContent = "NOTICE";
            document.querySelector("#genericStatusModal .message").innerHTML =
                "We've added a random track to the calculator for you to explore our pricings with.<br />You can find the right one with our search tools later.";
            jQuery("#genericStatusModal").modal("show");
            setTimeout(() => {
                document.querySelector("#genericStatusModal .medium-title").textContent = "";
                document.querySelector("#genericStatusModal .message").textContent = "";
                jQuery("#genericStatusModal").modal("hide");
            }, 10000);
        } else if (window.localStorage.getItem("licenses_tracks")) {
            window.localStorage
                .getItem("licenses_tracks")
                .split(",")
                .map((id) => {
                    const licensesTrack = new LicensesTrack({ id });
                    _this.licensesTracks.push(licensesTrack);
                });
        }

        if (payment) {
            const modal = "#licensesStatusModal";
            if (payment === "OK") {
                window.localStorage.setItem("licenses_tracks", "");
                document.querySelector("#mainMenu .licenses .nav-link .badge").textContent = "";
                document.querySelector(`${modal} .message`).textContent = "Payment OK";
                setTimeout(() => {
                    window.location.href = this.redirectIfEmptyUrl;
                }, 2000);
            } else {
                document.querySelector(`${modal} .message`).textContent = "Payment ERROR";
            }
            jQuery(modal).modal("show");
            setTimeout(() => jQuery(modal).modal("hide"), 3000);
        } else {
            setTimeout(() => {
                document.querySelector("#licensesTracksList").innerHTML = `<div class="js-preloader inpage"><div class="spinner"></div></div>`;
                jQuery("#licensesTracksList .js-preloader").show();

                let url = `${Globals.WS_URL}?mode=ADVCALC`;
                if (token) {
                    url = `${url}&token=${token}`;
                }

                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Fetching Page data");
                fetch(url)
                    //fetch(`/apisounzone/getadvcal/`+token)
                    .then(this.handleResponse)
                    .then((result) => {
                        if (result.error) {
                            window.location.href = this.redirectIfEmptyUrl;
                        }
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Fetch Page data OK");
                        this.page = result.data;
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(this.page);
                        this.setupTerritoryModals();
                        this.getPrice();
                        if (token) {
                            document.querySelector("#licensesPanel .quotation").addEventListener("click", (event) => {
                                _this.requestQuotation();
                            });
                            document.querySelector("#licensesPanel .buy").addEventListener("click", (event) => {
                                _this.requestBuy();
                            });
                        } else {
                            document.querySelector("#licensesPanel .quotation").setAttribute("data-target", "#loginModal");
                            document.querySelector("#licensesPanel .quotation").setAttribute("data-toggle", "modal");
                            document.querySelector("#licensesPanel .buy").setAttribute("data-target", "#loginModal");
                            document.querySelector("#licensesPanel .buy").setAttribute("data-toggle", "modal");
                        }
                    })
                    .catch((error) => {
                        Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                        jQuery(".js-critical-error").show();
                    });
            }, 200);
        }
    }

    updateSummary() {
        document.querySelector("#licensesPanel .total").textContent =
            this.licensesTracks.length > 1 ? `${this.licensesTracks.length} TRACKS` : `${this.licensesTracks.length} TRACK`;
        if (!this.userLogged || !this.userManager.isActiveSubscription()) {
            document.querySelector("#licensesPanel .licenses-save").style.display = "";
        }
    }

    setupTerritoryModals() {
        const _this = this;

        const primary = this.page.Zones.filter((item) => item.parent === 0);
        primary.map((parent) => {
            if (parent.name === "Areas") {
                this.areas = this.page.Zones.filter((item) => item.parent === parent.ID);
            } else if (parent.name === "Continents") {
                this.continents = this.page.Zones.filter((item) => item.parent === parent.ID);
            } else if (parent.name === "Countries") {
                this.countries = this.page.Zones.filter((item) => item.parent === parent.ID);
            } else if (parent.name === "National") {
                this.national = parent;
            } else if (parent.name === "World") {
                this.world = parent;
            }
        });

        const territoryModal = document.querySelector("#territoryModal");
        this.countries.map((country) => {
            const modelId = "#model-licenses-territory-checkbox";
            const countryItem = document.querySelector(`${modelId} .form-check`).cloneNode(true);
            countryItem.querySelector(".form-check-input").value = country.ID;
            countryItem.querySelector(".form-check-input").id = `countryLicenses${country.ID}`;
            countryItem.querySelector(".form-check-label").textContent = country.name;
            countryItem.querySelector(".form-check-label").setAttribute("for", `countryLicenses${country.ID}`);

            countryItem.querySelector(".form-check-input").addEventListener("click", (event) => {
                _this.setZoneValue(event.target);
            });

            territoryModal.querySelector("#nations .territory-checkbox-list").appendChild(countryItem);
        });
        this.areas.map((area) => {
            const modelId = "#model-licenses-territory-checkbox";
            const areaItem = document.querySelector(`${modelId} .form-check`).cloneNode(true);
            areaItem.querySelector(".form-check-input").value = area.ID;
            areaItem.querySelector(".form-check-input").id = `areaLicenses${area.ID}`;
            areaItem.querySelector(".form-check-label").textContent = area.name;
            areaItem.querySelector(".form-check-label").setAttribute("for", `areaLicenses${area.ID}`);

            areaItem.querySelector(".form-check-input").addEventListener("click", (event) => {
                _this.setZoneValue(event.target);
            });

            territoryModal.querySelector("#areas .territory-checkbox-list").appendChild(areaItem);
        });
        this.continents.map((continent) => {
            const modelId = "#model-licenses-territory-checkbox";
            const continentItem = document.querySelector(`${modelId} .form-check`).cloneNode(true);
            continentItem.querySelector(".form-check-input").value = continent.ID;
            continentItem.querySelector(".form-check-input").id = `continentLicenses${continent.ID}`;
            continentItem.querySelector(".form-check-label").textContent = continent.name;
            continentItem.querySelector(".form-check-label").setAttribute("for", `continentLicenses${continent.ID}`);

            continentItem.querySelector(".form-check-input").addEventListener("click", (event) => {
                _this.setZoneValue(event.target);
            });

            territoryModal.querySelector("#continents .territory-checkbox-list").appendChild(continentItem);
        });

        territoryModal.querySelector(".total-selected").addEventListener("click", () => {
            _this.requestPriceUpdate(_this.territoryLicensesTrackSelected.data.id);
            setTimeout(() => {
                // territoryModal.querySelector(`.nav-item.areas a.nav-link`).classList.remove("active");
                territoryModal.querySelector(`.tab-content #areas`).classList.remove("active", "show");
                territoryModal.querySelector(`.nav-item.continents a.nav-link`).classList.remove("active");
                territoryModal.querySelector(`.tab-content #continents`).classList.remove("active", "show");
                territoryModal.querySelector(`.nav-item.nations a.nav-link`).classList.add("active");
                territoryModal.querySelector(`.tab-content #nations`).classList.add("active", "show");
            }, 500);
        });
    }

    setZoneValue(target) {
        const licensesTrack = this.territoryLicensesTrackSelected;
        if (target.checked) {
            licensesTrack.data.zone.push(target.value);
        } else {
            licensesTrack.data.zone.splice(licensesTrack.data.zone.indexOf(target.value), 1);
        }
        this.updateTerritoryModal();
        territoryModal.querySelector(".total-selected").disabled = licensesTrack.data.zone.length > 0 ? false : true;
    }

    updateTerritoryModal() {
        const licensesTrack = this.territoryLicensesTrackSelected;
        const territoryModal = document.querySelector("#territoryModal");

        this.updateTerritoryTab(territoryModal, "nations");
        // this.updateTerritoryTab(territoryModal, "areas");
        this.updateTerritoryTab(territoryModal, "continents");

        if (licensesTrack.data.zone.length > 0) {
            territoryModal.querySelector(".total-selected .counter").textContent = `(${licensesTrack.data.zone.length})`;
        }
    }

    updateTerritoryTab(territoryModal, tab) {
        const inputs = territoryModal.querySelectorAll(`#${tab} .form-check-input`);
        let counter = 0;
        Array.from(inputs).map((input) => {
            if (this.territoryLicensesTrackSelected.data.zone.indexOf(input.value) > -1) {
                input.checked = true;
                counter++;
            } else {
                input.checked = false;
            }
        });
        if (counter > 0) {
            territoryModal.querySelector(`.nav-item.${tab} .counter`).textContent = `(${counter})`;
        } else {
            territoryModal.querySelector(`.nav-item.${tab} .counter`).textContent = "";
        }
    }

    getPrice(update) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Fetching Price");
        const token = this.getCookie("user_token");
        const tracks_data = this.licensesTracks.map((licensesTrack) => licensesTrack.data);
        fetch(`${Globals.WS_URL}?mode=ADVCALC.PRICE&token=${token}&tracks_data=${JSON.stringify(tracks_data)}`)
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Fetch Price OK");
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                let _new = false;
                if (this.total === 0) {
                    _new = true;
                }
                this.total = result.prices.total;
                this.prices = result.prices.tracks;
                this.prices.map((item, index) => {
                    const track = this.tracks.get({ id: item.id });
                    const licensesTrack = this.licensesTracks.filter((item) => item.data.id === track.data.ID)[0];
                    // PQP (non mi è chiaro molto questo pezzo ma probabilmente gli altri valori non servono al renderSingleItem)
                    licensesTrack.price.single_included = item.single_included;
                    if (!update) {
                        track.setupArtistsObject(this.artists);
                        this.renderSingleItem(track.data, index, licensesTrack);
                    }
                    licensesTrack.price.digital = item.digital;
                    licensesTrack.price.offline = item.offline;
                    licensesTrack.price.single_license = item.single_licence;
                    // PQP
                    licensesTrack.price.digital_included = item.digital_included;

                    this.updateSingleItem(licensesTrack);
                });
                this.updateTotal();
                if (_new) {
                    this.emitEvent("all_data_loaded");
                }
                jQuery(".js-preloader").hide();
                this.isWorking = false;
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
                this.isWorking = false;
            });
    }

    updateTotal() {
        const licensesPanel = document.querySelector("#licensesPanel");
        licensesPanel.querySelector(".amount .price").textContent = `€ ${this.formatPrice(this.total)}`;
        licensesPanel.querySelector(".amount .vat").textContent = this.isVatString;
        if (this.userLogged) {
            licensesPanel.querySelector(".btns-container .quotation").disabled = true;
            licensesPanel.querySelector(".btns-container .buy").disabled = true;
            if (this.checkLicensesTracksPrices() && this.checkLicensesTracksValidity()) {
                licensesPanel.querySelector(".btns-container .quotation").disabled = false;
                licensesPanel.querySelector(".btns-container .buy").disabled = false;
            }
        }
        this.updateSummary();
    }

    renderSingleItem(track, index, licensesTrack) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Render Single Item");

        const _this = this;

        const modelId = "#model-licenses-single-item";
        const licensesSingleTrack = document.querySelector(`${modelId} .licenses-single-track`).cloneNode(true);

        licensesSingleTrack.id = `licensesSingleItem${track.ID}`;
        licensesSingleTrack.querySelector(".delete").addEventListener("click", (event) => {
            // this.isWorking = true;
            if (this.isWorking) {
                // alert("Work in progress, please wait");
                return;
            }
            this.isWorking = true;
            // ---
            event.preventDefault();
            licensesSingleTrack.remove();
            _this.licensesTracks.splice(_this.licensesTracks.indexOf(licensesTrack), 1);
            const tracks_data = window.localStorage.getItem("licenses_tracks").split(",");
            tracks_data.splice(tracks_data.indexOf(track.ID.toString()), 1);
            window.localStorage.setItem("licenses_tracks", tracks_data.join(","));
            document.querySelector("#mainMenu .licenses .nav-link .badge").textContent = tracks_data.length === 0 ? "" : tracks_data.length;
            _this.updateMenuLicensesTable();
            _this.getPrice(true);
        });

        licensesSingleTrack.querySelector(".licenses-track-info .title .info-content").innerHTML = track.Name;
        licensesSingleTrack.querySelector(".licenses-track-info .artist .info-content").innerHTML = track.Artists.map((artist) => {
            if (artist) {
                return artist.get().Name;
            }
            return "";
        }).join(", ");
        licensesSingleTrack.querySelector(".licenses-track-info .length .info-content").textContent = track.MP3.LengthFMT;
        licensesSingleTrack.querySelector(".licenses-track-info .catalogue .info-content").textContent = track.Artists[0].data.Format;

        licensesSingleTrack.querySelector(".license-data input[name=pjName]").addEventListener("keyup", (event) => {
            licensesTrack.data.prj_name = _this.cleanInput(event.target.value);
            event.target.classList.remove("is-invalid");
            _this.updateTotal();
        });
        licensesSingleTrack.querySelector(".license-data input[name=client]").addEventListener("keyup", (event) => {
            licensesTrack.data.prj_client = _this.cleanInput(event.target.value);
            event.target.classList.remove("is-invalid");
            _this.updateTotal();
        });

        licensesSingleTrack.querySelector(".standard-license").classList.add("active");
        licensesSingleTrack.querySelector(".standard-license .group-selector input").name = `licenseType-${licensesTrack.data.id}`;
        licensesSingleTrack.querySelector(".standard-license .group-selector input").checked = true;
        licensesTrack.data.single_licence = true;
        licensesTrack.price.single_license = this.page.SingleLicence.price;
        if (licensesTrack.price.single_included) {
            licensesSingleTrack.querySelector(".standard-license .total").style.display = "none";
            licensesSingleTrack.querySelector(".standard-license .price").innerHTML = `<span style="font-size:1.5rem">Included</span>`;
        } else {
            licensesSingleTrack.querySelector(".standard-license .total").style.display = "";
            licensesSingleTrack.querySelector(".standard-license .price").textContent = `€ ${this.formatPrice(this.page.SingleLicence.price)}`;
            licensesSingleTrack.querySelector(".standard-license .vat").textContent = this.isVatString;
        }
        licensesSingleTrack.querySelector(".standard-license .group-selector input").addEventListener("click", () => {
            licensesSingleTrack.querySelector(".standard-license").classList.add("active");
            licensesSingleTrack.querySelector(".commercial-license").classList.remove("active");
            licensesTrack.data.single_licence = true;
            _this.requestPriceUpdate(licensesTrack.data.id);
        });

        licensesSingleTrack.querySelector(".commercial-license").classList.remove("active");
        licensesSingleTrack.querySelector(".commercial-license .group-selector input").name = `licenseType-${licensesTrack.data.id}`;
        licensesSingleTrack.querySelector(".commercial-license .group-selector input").checked = false;
        licensesSingleTrack.querySelector(".commercial-license .group-selector input").addEventListener("click", () => {
            licensesSingleTrack.querySelector(".commercial-license").classList.add("active");
            licensesSingleTrack.querySelector(".standard-license").classList.remove("active");
            licensesTrack.data.single_licence = false;
            _this.requestPriceUpdate(licensesTrack.data.id);
        });

        // ---

        if (this.userLogged) {
            // console.log(this.userLogged);
            if (this.userLogged.cc == 4) {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Auto select commercial");
                // document.querySelector(".license-box-label.commercial-license").click();
                licensesSingleTrack.querySelector(".commercial-license .group-selector input").checked = true;
                // ---
                licensesSingleTrack.querySelector(".commercial-license").classList.add("active");
                licensesSingleTrack.querySelector(".standard-license").classList.remove("active");
                licensesTrack.data.single_licence = false;
                _this.requestPriceUpdate(licensesTrack.data.id);
            }
        }

        // ---

        licensesSingleTrack.querySelector(".reset-digital").addEventListener("click", (event) => {
            event.preventDefault();
            const inputs = licensesSingleTrack.querySelectorAll(".digital-list input");
            Array.from(inputs).map((input) => {
                input.checked = false;
            });
            licensesSingleTrack.querySelector(".licenses-block-subtitle .text-muted").textContent = "";
            licensesTrack.data.digital = 0;
            _this.requestPriceUpdate(licensesTrack.data.id);
        });

        this.page.Digital.map((digital) => {
            const modelId = "#model-licenses-single-digital-item";
            const digitalItem = document.querySelector(`${modelId} .item`).cloneNode(true);
            digitalItem.querySelector(".form-check-input").value = digital.ID;
            digitalItem.querySelector(".form-check-input").id = `digitalLicenses${track.ID}${digital.ID}`;
            digitalItem.querySelector(".form-check-input").name = `digitalLicenses${track.ID}`;
            digitalItem.querySelector(".form-check-label").textContent = digital.name;
            digitalItem.querySelector(".form-check-label").setAttribute("for", `digitalLicenses${track.ID}${digital.ID}`);

            digitalItem.querySelector(".form-check-input").addEventListener("click", (event) => {
                licensesSingleTrack.querySelector(".licenses-block-subtitle .text-muted").textContent = digital.description;
                licensesTrack.data.digital = event.target.value;
                Array.from(licensesSingleTrack.querySelectorAll(".media-list input")).map((input) => {
                    if (input.dataset.exclusive === "true" && licensesTrack.data.media.indexOf(input.dataset.id) > -1) {
                        input.checked = false;
                        licensesTrack.data.media.splice(licensesTrack.data.media.indexOf(input.dataset.id), 1);
                    }
                });
                _this.requestPriceUpdate(licensesTrack.data.id);
            });

            licensesSingleTrack.querySelector(".digital-list").appendChild(digitalItem);
        });

        this.page.Media.map((media) => {
            const modelId = "#model-licenses-single-media-item";
            const mediaItem = document.querySelector(`${modelId} .item`).cloneNode(true);
            mediaItem.querySelector(".form-check-input").value = media.ID;
            mediaItem.querySelector(".form-check-input").id = `mediaLicenses${media.ID}`;
            mediaItem.querySelector(".form-check-input").dataset.id = media.ID;
            mediaItem.querySelector(".form-check-input").dataset.exclusive = media.exclusive;
            mediaItem.querySelector(".form-check-label .name").textContent = media.name;
            mediaItem.querySelector(".form-check-label .info").setAttribute("title", media.description.replace(/<\/?[^>]+(>|$)/g, ""));
            // mediaItem.querySelector(".form-check-label .icon-info .desc").textContent = media.description; // 220913 - Popup Info
            mediaItem.querySelector(".form-check-label").setAttribute("for", `mediaLicenses${media.ID}`);

            mediaItem.querySelector(".form-check-input").addEventListener("click", (event) => {
                if (event.target.checked) {
                    if (event.target.dataset.exclusive === "true") {
                        Array.from(licensesSingleTrack.querySelectorAll(".media-list input")).map((input) => {
                            if (input.dataset.id !== event.target.dataset.id) {
                                input.checked = false;
                                licensesTrack.data.media.splice(licensesTrack.data.media.indexOf(event.target.dataset.id), 1);
                            }
                        });
                        /* // No Digital on All Media Package (752)
                        Array.from(licensesSingleTrack.querySelectorAll(".digital-list input")).map((input) => {
                            input.checked = false;
                        });
                        licensesTrack.data.digital = 0;
                        //*/
                    } else {
                        Array.from(licensesSingleTrack.querySelectorAll(".media-list input")).map((input) => {
                            if (input.dataset.exclusive === "true" && licensesTrack.data.media.indexOf(input.dataset.id) > -1) {
                                input.checked = false;
                                licensesTrack.data.media.splice(licensesTrack.data.media.indexOf(input.dataset.id), 1);
                            }
                        });
                    }
                    licensesTrack.data.media.push(event.target.value);
                } else {
                    licensesTrack.data.media.splice(licensesTrack.data.media.indexOf(event.target.value), 1);
                }
                _this.requestPriceUpdate(licensesTrack.data.id);
            });

            licensesSingleTrack.querySelector(".media-list").appendChild(mediaItem);
        });

        licensesSingleTrack.querySelector(".offline .period-calc .minus").addEventListener("click", (event) => {
            event.preventDefault();
            if (licensesTrack.data.time !== 0) {
                licensesTrack.data.time -= _this.timeSteps;
                licensesSingleTrack.querySelector(".offline .period-calc .period-value").textContent = `${licensesTrack.data.time} months`;
                _this.requestPriceUpdate(licensesTrack.data.id);
            }
        });
        licensesSingleTrack.querySelector(".offline .period-calc .plus").addEventListener("click", (event) => {
            event.preventDefault();
            licensesTrack.data.time += _this.timeSteps;
            licensesSingleTrack.querySelector(".offline .period-calc .period-value").textContent = `${licensesTrack.data.time} months`;
            _this.requestPriceUpdate(licensesTrack.data.id);
        });

        licensesSingleTrack.querySelector(".add-territory").addEventListener("click", (event) => {
            _this.territoryLicensesTrackSelected = licensesTrack;
            _this.updateTerritoryModal();
        });

        licensesSingleTrack.querySelector(".territory-worldwide").addEventListener("click", (event) => {
            if (event.target.checked) {
                const modal = "#territoryProceedModal";
                jQuery(modal).modal("show");
                _this.territoryLicensesTrackSelected = licensesTrack;
            } else {
                licensesTrack.data.zone = [];
                licensesSingleTrack.querySelector(".tags-list").textContent = "";
                licensesSingleTrack.querySelector(".tags-list").style.display = "flex";
                licensesSingleTrack.querySelector(".add-territory").style.display = "flex";
                _this.requestPriceUpdate(licensesTrack.data.id);
            }
        });

        // licensesSingleTrack.querySelector(".reset-exclusive").addEventListener("click", (event) => {
        //     event.preventDefault();
        //     const inputs = licensesSingleTrack.querySelectorAll(".exclusive-list input");
        //     Array.from(inputs).map((input) => {
        //         input.checked = false;
        //     });
        //     licensesTrack.data.exclusive = 0;
        //     _this.requestPriceUpdate(licensesTrack.data.id);
        // });

        // this.exclusiveTypes.map((name, index) => {
        //     const modelId = "#model-licenses-single-exclusive-item";
        //     const exclusiveItem = document.querySelector(`${modelId} .item`).cloneNode(true);
        //     exclusiveItem.querySelector(".form-check-input").value = index;
        //     exclusiveItem.querySelector(".form-check-input").id = `exclusiveLicenses${track.ID}${index}`;
        //     exclusiveItem.querySelector(".form-check-input").name = `exclusiveLicenses${track.ID}`;
        //     exclusiveItem.querySelector(".form-check-label").textContent = name;
        //     exclusiveItem.querySelector(".form-check-label").setAttribute("for", `exclusiveLicenses${track.ID}${index}`);

        //     exclusiveItem.querySelector(".form-check-input").addEventListener("click", (event) => {
        //         licensesTrack.data.exclusive = event.target.value;
        //         _this.requestPriceUpdate(licensesTrack.data.id);
        //     });

        //     licensesSingleTrack.querySelector(".exclusive-list").appendChild(exclusiveItem);
        // });

        document.querySelector("#licensesTracksList").appendChild(licensesSingleTrack);
    }

    requestPriceUpdate(id) {
        // jQuery(`#licensesSingleItem${id} .js-preloader`).show();
        this.getPrice(true);
    }

    updateSingleItem(licensesTrack) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Update Single Item");

        const licensesSingleTrack = document.querySelector(`#licensesSingleItem${licensesTrack.data.id}`);

        const allLicenses = document.querySelectorAll("#licensesTracksList .licenses-single-track");
        const index = Array.from(allLicenses).indexOf(licensesSingleTrack);
        licensesSingleTrack.querySelector(".single-track-title").textContent = `Track #${index + 1}`;

        Array.from(licensesSingleTrack.querySelectorAll(".license-data input")).map((input) => {
            if (input.name === "pjName") input.value = licensesTrack.data.prj_name;
            if (input.name === "client") input.value = licensesTrack.data.prj_client;
        });
        //debugger
        if (licensesTrack.price.digital !== 0) {
            licensesSingleTrack.querySelector(".digital .licenses-total-amount").style.display = "";
            licensesSingleTrack.querySelector(".digital .licenses-total-amount .label").style.display = "";
            licensesSingleTrack.querySelector(".digital .licenses-total-amount .price").textContent = `€ ${this.formatPrice(licensesTrack.price.digital)}`;
            licensesSingleTrack.querySelector(".digital .licenses-total-amount .vat").textContent = this.isVatString;
        } else {
            if (licensesTrack.price.digital_included) {
                licensesSingleTrack.querySelector(".digital .licenses-total-amount").style.display = "";
                licensesSingleTrack.querySelector(".digital .licenses-total-amount .label").style.display = "";
                // licensesSingleTrack.querySelector(".digital .licenses-total-amount .price").innerHTML = `<span style="font-size:1.5rem">Included</span>`;
                licensesSingleTrack.querySelector(".digital .licenses-total-amount .price").innerHTML = `€ ${this.formatPrice(0)}`;
            } else {
                licensesSingleTrack.querySelector(".digital .licenses-total-amount").style.display = "none";
                licensesSingleTrack.querySelector(".digital .licenses-total-amount .label").style.display = "";
                licensesSingleTrack.querySelector(".digital .licenses-total-amount .price").textContent = "";
            }
        }

        if (licensesTrack.price.offline !== 0) {
            licensesSingleTrack.querySelector(".offline .licenses-total-amount").style.display = "";
            licensesSingleTrack.querySelector(".offline .licenses-total-amount .price").textContent = `€ ${this.formatPrice(licensesTrack.price.offline)}`;
            licensesSingleTrack.querySelector(".offline .licenses-total-amount .vat").textContent = this.isVatString;
        } else {
            licensesSingleTrack.querySelector(".offline .licenses-total-amount").style.display = "none";
            licensesSingleTrack.querySelector(".offline .licenses-total-amount .price").textContent = "";
        }

        licensesSingleTrack.querySelector(".tags-list").textContent = "";
        if (licensesTrack.data.zone.length > 0) {
            licensesTrack.data.zone.map((zoneId) => {
                const modelId = "#model-licenses-single-tag-territory-item";
                const zoneItem = document.querySelector(`${modelId} .tag-item`).cloneNode(true);

                const zone = this.page.Zones.filter((zone) => zone.ID === parseInt(zoneId))[0];

                zoneItem.querySelector(".name").textContent = zone.name;

                const _this = this;

                zoneItem.querySelector(".remove-tag-btn").addEventListener("click", () => {
                    zoneItem.remove();
                    licensesTrack.data.zone.splice(licensesTrack.data.zone.indexOf(zoneId), 1);
                    _this.requestPriceUpdate(licensesTrack.data.id);
                });

                licensesSingleTrack.querySelector(".tags-list").appendChild(zoneItem);
            });
        }
    }

    requestQuotation() {
        if (this.checkLicensesTracksValidity()) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Request Quotation");
            const token = this.getCookie("user_token");
            const tracks_data = this.licensesTracks.map((licensesTrack) => licensesTrack.data);
            fetch(`${Globals.WS_URL}?mode=ADVCALC.QUOTATION&token=${token}&tracks_data=${JSON.stringify(tracks_data)}`)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Request Quotation OK");
                    this.download(result.pdf_url);
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        }
    }

    requestBuy() {
        if (this.checkLicensesTracksValidity()) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Request Buy");
            const token = this.getCookie("user_token");
            const tracks_data = this.licensesTracks.map((licensesTrack) => licensesTrack.data);
            const url = `${Globals.WS_URL}?mode=ADVCALC.PAYMENT&token=${token}&tracks_data=${JSON.stringify(tracks_data)}&return_url_ok=${
                this.paymentUrl.return_url_ok
            }&return_url_err=${this.paymentUrl.return_url_err}`;
            // fetch(
            //     url
            // )
            //     .then(this.handleResponse)
            //     .then((result) => {
            //         if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LicensesManager - Request Buy OK");
            //         if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
            //     })
            //     .catch((error) => Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message }));
            window.open(url, "_self");
        } else {
            const modal = "#licensesStatusModal";
            document.querySelector(`${modal} .message`).textContent = "ERROR: check the data entered";
            jQuery(modal).modal("show");
            setTimeout(() => jQuery(modal).modal("hide"), 3000);
        }
    }

    checkLicensesTracksValidity() {
        let valid = true;
        this.licensesTracks.map((licensesTrack) => {
            if (licensesTrack.data.prj_name === "" || licensesTrack.data.prj_client === "") {
                if (valid) {
                    valid = false;
                }
                if (licensesTrack.data.prj_name === "") {
                    document.querySelector(`#licensesSingleItem${licensesTrack.data.id} input[name="pjName"]`).classList.add("is-invalid");
                }
                if (licensesTrack.data.prj_client === "") {
                    document.querySelector(`#licensesSingleItem${licensesTrack.data.id} input[name="client"]`).classList.add("is-invalid");
                }
            }
        });
        return valid;
    }

    checkLicensesTracksPrices() {
        let valid = true;
        this.licensesTracks.map((licensesTrack) => {
            if (licensesTrack.price.digital === 0 && licensesTrack.price.offline === 0 && licensesTrack.price.single_license === 0) {
                if (valid) {
                    valid = false;
                }
            }
        });
        return valid;
    }
}
